export default __webpack_public_path__ + "static/media/black-pawn.756f7855.png";